import { ONE_WEEK_END, ONE_WEEK_START } from "@/utils/dateUtils";
import { type WidgetSettingsDefinition } from "@repo/api";

import { COMMON_SETTINGS } from "./commonWidgetSettings";

export const TASKS_SETTINGS: WidgetSettingsDefinition[] = [
  {
    id: "TASK_TYPE",
    title: "",
    type: "task_select",
  },
  {
    id: "DATE_RANGE",
    title: "label.date_range",
    type: "date_range",
    defaultValue: [ONE_WEEK_START.toISOString(), ONE_WEEK_END.toISOString()],
  },
  { ...COMMON_SETTINGS.COWORKER, additionalControl: { defaultCoworker: true } },
  COMMON_SETTINGS.STORE,
];
